import { Box, Flex, FlexProps, Text, VStack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { Player } from "types";
import InlineSVG from "react-inlinesvg";
import { motion } from "framer-motion";
import { useAnimateScore } from "hooks/useAnimateScore";

const SVG = InlineSVG as any;

export type Props = {
  player: Player;
} & FlexProps &
  PropsWithChildren;

export const PlayerBox: React.FC<Props> = ({ player, children, ...rest }) => {
  const { score } = useAnimateScore(player.score);

  return (
    <Flex
      flex={1}
      w="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="8px"
      {...rest}
    >
      {player.nameSvg && (
        <Box w="100%" flex={1} minH={0}>
          <SVG
            src={player.nameSvg}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </Box>
      )}
      <VStack spacing="2px">
        <Text textStyle="clue" fontSize="2.5vh" lineHeight="1.2">
          {player.name}
        </Text>
        <Text textStyle="score" fontSize="2.5vh" lineHeight="1.2">
          <motion.div>{score}</motion.div>
        </Text>
      </VStack>
    </Flex>
  );
};
